/*
 *###############################################################################
 *Module Name                   : VenderControler.js                            #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               :  Minol Prageesha                              #
 *Date                          : Thursday, September 9th 2021, 1:01:39 pm      #
 *Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
 *###############################################################################
 */

const getvenderdata = async () => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    redirect: "follow",
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  }
  await fetch(`${ApiURL}Supplier`, requestOptions)
    .then(response => response.json())
    .then(result => {
      //console.log(result)
      data = result.options
    })
    .catch(error => console.log("error", error))
  return data
}

const getTransactions = async () => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var responseData = []
  var requestOptions = {
    method: "GET",
    redirect: "follow",
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  }
  await fetch(`${ApiURL}common/txntype`, requestOptions)
    .then(response => response.json())
    .then(result => {
      responseData = result.data
    })
    .catch(error => console.log("error", error))
  return responseData
}

export { getTransactions }


// ********Save/Update button function API */
export const SaveVendorMaster = async (Suppliergenaral) => {
  try {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    const requestOptions = {

      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify(Suppliergenaral),
      redirect: "follow",
    }

    const response = await fetch(`${ApiURL}Supplier`, requestOptions);
    const responseData = await response.json();

    if (response.status == "200") {
      if (responseData.data == "Record Already Exsist!") {
        return { success: false, data: responseData.data };
      } else if (responseData.data == "Code Already Exist!") {
        return { success: false, data: responseData.data };
      } else {
        return { success: true, data: responseData.data };
      }
    } else {
      return { success: false, data: responseData.data };
    }
  } catch (error) {
    console.error("SaveVenderMasterDetails error:", error);
    return { success: false, data: "An error occurred." };
  }
};

// ********End of the Save/Update button function API */


// ********Delete button function API */
export const DeleteVenderMasterDetails = async (rowDelete) => {
  try {

    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    const requestOptions = {

      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify(rowDelete),

    };

    const response = await fetch(`${ApiURL}Common/Delete`, requestOptions);
    const responseData = await response.json();

    if (response.status == "200") {
      if (responseData.data == "Cannot Delete, Record Already Used!") {
        return { success: false, data: responseData.data };

      } else {
        return { success: true, data: responseData.data }
      }
    } else {
      return { success: false, data: responseData.data };
    }
  } catch (error) {
    console.error("DeleteVenderMasterDetails error:", error);
  }
};

// ********End of Delete button function API */

// *** Get and Set values when user search code function API*/
export const VenderMasterDetailsGetData = async (CodeFind) => {
  try {
    const ApiURL = window.Links.ApiURL;
    const authToken = localStorage.getItem("authToken");

    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      }

    };
    const response = await fetch(`${ApiURL}Supplier/search/${CodeFind}`, requestOptions);
    const responseData = await response.json();

    if (response.status == "200") {
      if (responseData.success && responseData.data.length > 0) {
        return { success: true, data: responseData.data[0] };
      }else{
        return { success: false, data: {} };
      }
    } else {
      return { success: false, data: {} };
    }

  } catch (error) {
    console.error("Error fetching data:", error);
    return { success: false, data: {} };
  }
}


export const handleUploadSuppliers = async (file, logUser, logLocation) => {
  const formData = new FormData();
  formData.append('excelFile', file);
  formData.append('user', logUser);
  formData.append('location', logLocation);

  const ApiURL = window.Links.ApiURL;
  const authToken = localStorage.getItem("authToken");

  try {
    const response = await fetch(`${ApiURL}supplier/upload`, {
      method: 'POST',
      body: formData,
      headers: {
        'Authorization': `Bearer ${authToken}`
      }
    });
    const data = await response.json();

    if (response.ok) {
      if (data.success == true) {
        return { success: true, successTable: JSON.parse(data.successTable), unsuccessTable: JSON.parse(data.unsuccessTable), msg: data.msg };
      } else {
        return { success: false, successTable: [], unsuccessTable: [], msg: data.msg };
      }
    } else {
      return { success: false, successTable: [], unsuccessTable: [], msg: data.msg };
    }
  } catch (error) {
    console.error('Error uploading file:', error);
    return { success: false, msg: 'Error uploading file' };
    // Handle errors
  }
};

// *** End of Get and Set values when user search code function API*/